import React from "react";

/**
 * Configuration
 */
import config from "../config";
const { icons } = config;

const SearchInput = ({ label, placeholder, value, onChange, onClear }) => {
	return (
		<div className="search-input">
			<div className="search-input__wrapper">
				<input
					type="text"
					className="search-input__input"
					value={value}
					placeholder={placeholder}
					onChange={({ target: { value } }) => onChange(value)}
				/>
				{!value ? (
					<div
						className="search-input__icon search-input__icon--search"
						dangerouslySetInnerHTML={{
							__html: icons.search,
						}}
					/>
				) : (
					<button
						className="search-input__icon"
						dangerouslySetInnerHTML={{
							__html: icons.clear,
						}}
						onClick={onClear}
					/>
				)}
			</div>
		</div>
	);
};

export default SearchInput;
